import { CarouselProps } from 'react-material-ui-carousel/dist/components/types';
import { ReactElement } from 'react';
import { SortingArrowLeftIcon, SortingArrowRightIcon } from '@synergy/theme-next';
import { Theme, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Carousel from 'react-material-ui-carousel';

import { IndicatorIcon } from './indicator-icon';
import { useIsMobile } from '../hooks';

const useStyles = makeStyles((theme: Theme) => ({
    navButton: {
        '&:hover': {
            backgroundColor: 'rgb(12, 124, 213) !important',
            opacity: '1 !important',
        },
    },
    navButtonWrapper: {
        '&:hover button': {
            filter: 'none !important',
            opacity: '1 !important',
        },
    },
    indicatorButtonOwn: {
        '&:hover': {
            color: `${theme.palette.primary.main} !important`,
        },
    },
    activeIndicatorButtonOwn: {
        '& svg': {
            color: 'inherit !important',
        },
    },
}));

type PoolCarouselOwnProps = {
    justifyIndicatorButton?: 'left' | 'center' | 'right';
    alignIndicatorButton?: 'top' | 'bottom';
};

export type PoolCarouselProps = CarouselProps & PoolCarouselOwnProps;

export const PoolCarousel = (props: PoolCarouselProps): ReactElement => {
    const theme = useTheme();
    const isMobile = useIsMobile();
    const { justifyIndicatorButton = 'center', alignIndicatorButton = 'top', ...carouselProps } = props;
    const classes = useStyles();

    return (
        <Carousel
            {...carouselProps}
            indicatorIconButtonProps={{
                className: classes.indicatorButtonOwn,
                style: {
                    minWidth: theme.spacing(1.5),
                    minHeight: theme.spacing(1.5),
                    width: 0,
                    height: 0,
                    marginLeft: theme.spacing(1.75),
                    marginRight: theme.spacing(1.75),
                    padding: 0,

                    color: alignIndicatorButton === 'top' ? theme.palette.common.white : theme.palette.grey[200],
                },
            }}
            activeIndicatorIconButtonProps={{
                className: classes.activeIndicatorButtonOwn,
                style: {
                    color: theme.palette.primary.main,
                },
            }}
            indicatorContainerProps={{
                style: {
                    textAlign: justifyIndicatorButton === 'center' ? 'center' : 'end',
                    ...(alignIndicatorButton === 'top' ? { bottom: 58 } : { bottom: 0 }),
                    ...(isMobile && justifyIndicatorButton === 'right' && { bottom: 50, right: 10 }),
                    position: 'relative',
                    marginTop: theme.spacing(),
                    zIndex: 2,
                },
            }}
            IndicatorIcon={<IndicatorIcon sx={{ fontSize: 12 }} />}
            NextIcon={<SortingArrowRightIcon />}
            PrevIcon={<SortingArrowLeftIcon />}
            navButtonsProps={{
                className: classes.navButton,
                style: {
                    marginLeft: theme.spacing(3),
                    marginRight: theme.spacing(3),
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.common.white,
                },
            }}
            navButtonsWrapperProps={{
                className: classes.navButtonWrapper,
            }}
            navButtonsAlwaysInvisible={isMobile}
        />
    );
};
